import React from "react";
const SvgNearbyBike = props => (
  <svg fill="none" viewBox="0 0 28 28" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M16.333 6.417c0-.323.262-.584.584-.584h2.333c.273 0 .51.19.57.457l1.2 5.406a5.25 5.25 0 11-1.14.252l-.332-1.504-6.885 6.885a.583.583 0 01-.413.171h-.615a5.25 5.25 0 01-5.218 4.667 5.25 5.25 0 01-5.25-5.25 5.249 5.249 0 017.545-4.72l.883-.98-.673-1.884h-.755a.583.583 0 110-1.166h3.5a.583.583 0 110 1.166H10.16l.409 1.144 8.625-1.618L18.782 7h-1.865a.583.583 0 01-.584-.583zm-6.292 6.048L6.56 16.333h4.862l-1.381-3.868zm2.448 3.387l-1.522-4.263 7.12-1.335-5.598 5.598zM6.417 21a4.083 4.083 0 004.042-3.5H5.25a.583.583 0 01-.434-.974l3.075-3.415a4.082 4.082 0 00-5.557 3.806A4.082 4.082 0 006.416 21zm14.597-3.957l-.877-3.946A4.085 4.085 0 0021.583 21a4.083 4.083 0 10-.307-8.155l.877 3.945a.583.583 0 01-1.139.253z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNearbyBike;
